import { EN_LOCALE, HE_LOCALE, AR_LOCALE, EN_US_LOCALE, EN_GB_LOCALE, HE_IL_LOCALE, AR_SA_LOCALE, AR_EG_LOCALE, HEB_LOCALE, ENG_LOCALE, ARA_LOCALE } from '../internationalization/internationalization';
import { getCurrentLanguage, getLegacyLanguage, getVideoType } from '../services/localStorage';

export interface DeviceInfo {
  Site: string;
  Device: string;
  Browser: string;
  'Browser Version': string;
  'Default Language': string;
  'Connection Type': string;
  'Interface Language': string | undefined;
  'Current Language Code': string;
  'Video Language'?: string;
  [key: string]: string | undefined;
}

function parseBrowserName(ua: string): string {
    if (/Edg\//i.test(ua)) return 'Edge';
    if (/SamsungBrowser\//i.test(ua)) return 'Samsung Browser';
    if (/OPR\/|Opera\//i.test(ua)) return 'Opera';
    if (/Chrome\//i.test(ua) && !/Edg\//i.test(ua)) return 'Chrome';
    if (/CriOS\//i.test(ua)) return 'Chrome';
    if (/FxiOS\//i.test(ua)) return 'Firefox';
    if (/Firefox\//i.test(ua)) return 'Firefox';
    if (/Safari\//i.test(ua) && !/Chrome\//i.test(ua)) return 'Safari';
    return 'Unknown';
}

function parseBrowserVersion(ua: string): string {
    const patterns: [RegExp, number][] = [
        [/Edg\/([\d.]+)/i, 1],
        [/SamsungBrowser\/([\d.]+)/i, 1],
        [/OPR\/([\d.]+)/i, 1],
        [/Chrome\/([\d.]+)/i, 1],
        [/CriOS\/([\d.]+)/i, 1],
        [/FxiOS\/([\d.]+)/i, 1],
        [/Firefox\/([\d.]+)/i, 1],
        [/Version\/([\d.]+).*Safari/i, 1],
    ];
    for (const [regex, group] of patterns) {
        const match = ua.match(regex);
        if (match?.[group]) return match[group];
    }
    return 'Unknown';
}

export function getUserDeviceInfo(): DeviceInfo {
    const nav = navigator as Navigator & { connection?: { effectiveType?: string }; mozConnection?: { effectiveType?: string }; webkitConnection?: { effectiveType?: string } };
    const connection = nav.connection || nav.mozConnection || nav.webkitConnection;
    const connectionType: string = connection?.effectiveType ?? 'unknown';
    
    const currentLanguage = getCurrentLanguage() || getLegacyLanguage() || 'unknown';
    
    const videoLanguageType = getVideoType();
    const ua = navigator.userAgent;
  
    const deviceInfo: DeviceInfo = {
      'Site': window.location.pathname.split('/')[1].toLocaleUpperCase(),
      'Device': ua,
      'Browser': parseBrowserName(ua),
      'Browser Version': parseBrowserVersion(ua),
      'Default Language': navigator.language,
      'Connection Type': connectionType,
      'Interface Language': getLanguageName(currentLanguage),
      'Current Language Code': currentLanguage
    };

    if (videoLanguageType) {
      deviceInfo['Video Language'] = videoLanguageType;
    }

    return deviceInfo;
}

interface LanguageMapping {
  browserLang: string;
  appLang: string;
}

const languageMap: LanguageMapping[] = [
    { browserLang: EN_LOCALE, appLang: 'English' },
    { browserLang: ENG_LOCALE, appLang: 'English' },
    { browserLang: EN_US_LOCALE, appLang: 'English' },
    { browserLang: EN_GB_LOCALE, appLang: 'English' },
    { browserLang: HE_LOCALE, appLang: 'Hebrew' },
    { browserLang: HE_IL_LOCALE, appLang: 'Hebrew' },
    { browserLang: HEB_LOCALE, appLang: 'Hebrew' },
    { browserLang: AR_LOCALE, appLang: 'Arabic' },
    { browserLang: AR_SA_LOCALE, appLang: 'Arabic' },
    { browserLang: AR_EG_LOCALE, appLang: 'Arabic' },
    { browserLang: ARA_LOCALE, appLang: 'Arabic' }
  ];
  

function getLanguageName(languageCode: string): string | undefined {
    const languageMapping = languageMap.find(lang => lang.browserLang === languageCode)
    return languageMapping ? languageMapping.appLang : undefined
}
